import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { Box, Grid, IconButton, InputAdornment, List, ListItem, ListItemSecondaryAction, ListItemText, MenuItem, Toolbar, Typography } from "@material-ui/core"
import { alertRoutine } from "../../../redux/Alerts/routines"
import { v4 } from 'uuid';
import { useSelector, useDispatch} from 'react-redux';
import { deleteCorrespondantRoutinePromiseCreator, getCorrespondantsRoutine, postCorrespondantRoutinePromiseCreator, putCorrespondantRoutinePromiseCreator } from '../../../redux/Correspondants/routines';
import { makeCorrespondantsSelector } from '../../../redux/Correspondants/selectors';
import { i18n, store } from '../../../index'
import { useTranslation } from 'react-i18next';
import theme from '../../../utils/theme';
import { AjvValidatorContext } from '../../../utils/context/AjvContext';
import { Controller, useForm } from 'react-hook-form';
import schema from './correspondantFormSchema';
import ParamAutocompleteField from '../../Tasks/forms/taskFormActionCreator';
import { MailOutline, MoreVert, Phone, PhoneAndroid } from '@material-ui/icons';
import CustomSelectTextField from '../MenuTextField';
import { simpleParamsFormActionCreator } from '../../Settings/forms/simpleParamsFormActionCreator';
import MuiTextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

const TextField = withStyles((theme) => ({
  root: {
    "& .MuiSelect-root, & .MuiInputBase-root input": {
      paddingTop: 10.5,
      paddingBottom: 10.5,
    },

    "& .MuiSelect-root": {
      display: 'flex',
      alignItems: 'center',
      '& .MuiListItemText-root, & > span' : {
        margin: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }
    },

    "&.MuiTextField-root label": {
      top: 0,
      '&[data-shrink="false"]' : {
        textOverflow: 'ellipsis',
        right: 36,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
      }
    },
    
    "&.MuiTextField-root label[data-shrink='true']": {
      top: 0
    },
    
  }
}))(MuiTextField);

const CustomTextField = ({
  control, 
  transform = {
    input: (value) => value,
    output: (e) => e
  },
  children,
  name, 
  ...rest
}) => {

  return <Controller
    name={name}
    control={control}
    render={({ field }) => 
      <TextField 
        {...field} 
        onChange={(e) => field.onChange(transform.output(e))}
        value={transform.input(field.value)}
        {...rest} 
      >{children}</TextField>}
  />
}

export function CorrespondantList ({parentAlertId}) {

  const dispatch = useDispatch()
  const correspondantsSelector = useMemo(makeCorrespondantsSelector, [])
  const correspondants = useSelector(correspondantsSelector)
  
  useEffect(() => {
    dispatch(getCorrespondantsRoutine.trigger())
  }, [])

  const handleEditCorrespondant = useCallback((correspondant, parentAlertId) => {
    return () => dispatch(correspondantFormActionCreator(correspondant, parentAlertId))
  }, [])

  return (
    <List>
      {
        correspondants.map(correspondant => (
          <ListItem key={correspondant.id}>
            <ListItemText primary={`${correspondant.lastname} ${correspondant.firstname}`} />
            <ListItemSecondaryAction>
              <IconButton size="small" onClick={handleEditCorrespondant( correspondant ,parentAlertId)}>
                <MoreVert />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))
      }
    </List>
  )
}

export const correspondantListActionCreator = () => {
  const alertId = v4()
  return alertRoutine.show({
    id: alertId,
    type: 'dialog',
    noPaddingContent: true,
    maxWidth: 'xs',
    headerActions: [
      {
        title: i18n.t('common:interface.add'),
        //color: theme().palette.error.main,
        action: (parentAlertId) => {
          store.dispatch(correspondantFormActionCreator(undefined, parentAlertId))
          //headerActionRef.current()
          // store.dispatch(push('/logout'))
          // store.dispatch(alertRoutine.rejectAll())
        }
      }
    ],
    title: "Liste des correspondants",
    //title: 'Modifier les '+type, //i18n.t('cephalo:interface.reset_analyse'),
    content: <CorrespondantList parentAlertId={alertId} />,
  })
}

function CorrespondantForm ({ submitRef = {}, correspondant = {}, parentAlertId,  ...rest}) {

  const {t} = useTranslation()
  const { ajvResolver } = React.useContext(AjvValidatorContext);
  const dispatch = useDispatch()

  const { register, handleSubmit, control, formState: { errors,  }, getValues} = useForm({
    defaultValues: {
      title: "",
      firstname: "",
      lastname: "",
      gender: "male",
      mode_adresse: "vous",
      category: "",
      email: "",
      phone: "",
      mobile_phone: "",
      adresse1: "",
      adresse2: "",
      postcode: "",
      city: "",
      note: "",
      ...correspondant
    },
    resolver: ajvResolver(schema)
  });
  

  submitRef.current =  async () => {
    let dataRef;
    await handleSubmit(async (data) => {
      console.log('handleSubmit', data)
      dataRef = data;
    })()
    return dataRef;
  }

  const handleEditCorrespondantTitleParams = useCallback(() => {
    //display an alert with 
    dispatch(simpleParamsFormActionCreator({title: t('correspondant.titre'), type: 'correspondant-titre'}))
  }, [])

  const handleEditCorrespondantCategoryParams = useCallback(() => {
    //display an alert with 
    dispatch(simpleParamsFormActionCreator({title: t('correspondant.category'), type: 'correspondant-category'}))
  }, [])

  const handleSendEmail = () => {
    const email = getValues("email")
    console.log('handleSendEmail', email)
    if(email)
      window.location = `mailto:${email}`;
  }


  return (
    <Box component="form" position="relative" display="flex" >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CustomSelectTextField
            type="correspondant-titre" 
            control={control}
            name={'title'} 
            variant="outlined" 
            size="small" 
            fullWidth
            label={t('correspondant.titre')}
            error={Boolean(errors.title)}
            helperText={errors?.title?.message}
            actionTitle={t('correspondant.Modifier les titres')}
            action={handleEditCorrespondantTitleParams}
            defaultItems={[
              t('correspondant.titles.doctor'),
              t('correspondant.titles.professor'),
              t('correspondant.titles.mrs'),
              t('correspondant.titles.mr'),
            ]}
          />
        </Grid>
        <Grid item xs={12} sm={6}/>
        <Grid item xs={12} sm={6} >
          <TextField 
            {...register('firstname')} 
            variant="outlined" 
            size="small" 
            fullWidth
            label={t('correspondant.firstname')}
            error={Boolean(errors.firstname)}
            helperText={errors?.firstname?.message}
            autoComplete="nope"
          />
        </Grid>
        <Grid item xs={12} sm={6} >
          <TextField 
            {...register('lastname')} 
            variant="outlined" 
            size="small" 
            fullWidth
            label={t('correspondant.lastname')}
            error={Boolean(errors.lastname)}
            helperText={errors?.lastname?.message}
            autoComplete="nope"
          />
        </Grid>
         <Grid item xs={12} sm={6} >
          <CustomTextField
            control={control}
            name="gender"
            select
            variant="outlined" 
            size="small" 
            fullWidth
            label={t('correspondant.gender')}
            error={Boolean(errors.gender)}
            helperText={errors?.gender?.message}
          >
            <MenuItem value={"male"}>
              {t('correspondant.male')}
            </MenuItem>
            <MenuItem value={"female"}>
              {t('correspondant.female')}
            </MenuItem>
          </CustomTextField>       
        </Grid>
        <Grid item xs={12} sm={6} >
          <CustomTextField 
            control={control}
            name="mode_adresse"
            select
            variant="outlined" 
            size="small" 
            fullWidth
            label={t('correspondant.mode_adresse')}
            error={Boolean(errors.mode_adresse)}
            helperText={errors?.mode_adresse?.message}
          >
            <MenuItem value={"vous"}>
              {t('correspondant.vous')}
            </MenuItem>
            <MenuItem value={"tu"}>
              {t('correspondant.tu')}
            </MenuItem>
          </CustomTextField>
        </Grid>
        <Grid item xs={12} sm={6} >
          <CustomSelectTextField
            type="correspondant-category" 
            control={control}
            name={'category'} 
            variant="outlined" 
            size="small" 
            fullWidth
            label={t('correspondant.category')}
            error={Boolean(errors.category)}
            helperText={errors?.category?.message}
            actionTitle={t('correspondant.Modifier les catégories')}
            action={handleEditCorrespondantCategoryParams}
            defaultItems={[
              t('correspondant.categories.dentist'),
              t('correspondant.categories.oral_surgeon'),
              t('correspondant.categories.maxillofacial_surgeon'),
              t('correspondant.categories.ent'),
              t('correspondant.categories.physiotherapist'),
              t('correspondant.categories.speech_therapist'),
            ]}
          />
        </Grid>
        <Grid item xs={12} sm={6} >
          <TextField 
            {...register('email')}
            variant="outlined" 
            size="small" 
            fullWidth
            label={t('correspondant.email')}
            error={Boolean(errors.email)}
            helperText={errors?.email?.message}
            autoComplete="nope"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {/* <IconButton
                    onClick={handleSendEmail}
                  > */}
                    <MailOutline color="action"/>
                  {/* </IconButton> */}
                </InputAdornment>
              )
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} >
          <TextField 
            {...register('phone')}
            variant="outlined" 
            size="small" 
            fullWidth
            label={t('correspondant.phone')}
            error={Boolean(errors.phone)}
            helperText={errors?.phone?.message}
            autoComplete="nope"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" >
                  {/* <IconButton
                    onClick={handleSendEmail}
                  > */}
                    <Phone color="action"/>
                  {/* </IconButton> */}
                </InputAdornment>
              )
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} >
          <TextField 
            {...register('mobile_phone')}
            variant="outlined" 
            size="small" 
            fullWidth
            label={t('correspondant.mobile_phone')}
            error={Boolean(errors.mobile_phone)}
            helperText={errors?.mobile_phone?.message}
            autoComplete="nope"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {/* <IconButton
                    onClick={handleSendEmail}
                  > */}
                    <PhoneAndroid color="action"/>
                  {/* </IconButton> */}
                </InputAdornment>
              )
            }}
          />
        </Grid>
        <Grid item xs={12} >
          <TextField 
            {...register('adresse1')}
            variant="outlined" 
            size="small" 
            fullWidth
            label={t('correspondant.adresse1')}
            error={Boolean(errors.adresse1)}
            helperText={errors?.adresse1?.message}
            autoComplete="nope"
          />
        </Grid>
        <Grid item xs={12} >
          <TextField 
            {...register('adresse2')}
            variant="outlined" 
            size="small" 
            fullWidth
            label={t('correspondant.adresse2')}
            error={Boolean(errors.adresse2)}
            helperText={errors?.adresse2?.message}
            autoComplete="nope"
          />
        </Grid>
        <Grid item xs={12} sm={6} >
          <TextField 
            {...register('postcode')}
            variant="outlined" 
            size="small" 
            fullWidth
            label={t('correspondant.postcode')}
            error={Boolean(errors.postcode)}
            helperText={errors?.postcode?.message}
            autoComplete="nope"
          />
        </Grid>
        <Grid item xs={12} sm={6} >
          <TextField 
            {...register('city')}
            variant="outlined" 
            size="small" 
            fullWidth
            label={t('correspondant.city')}
            error={Boolean(errors.city)}
            helperText={errors?.city?.message}
            autoComplete="nope"
          />
        </Grid>
        <Grid item xs={12} >
          <TextField 
            {...register('note')} 
            multiline 
            minRows={3} 
            variant="outlined" 
            size="small" 
            fullWidth
            label={t('correspondant.note')}
            error={Boolean(errors.note)}
            helperText={errors?.note?.message}
            autoComplete="nope"
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export const correspondantFormActionCreator = (correspondant, parentAlertId, cb = () => {}) => {
  const submitRef = { current: (x) => console.log('old submit') }

  return alertRoutine.show({
    type: 'dialog',
    maxWidth: 'sm',
    fullScreenSmallScreen: true,
    scroll: 'body',
    disableEnforceFocus: true,
    title: !correspondant ? "Ajouter un correspondant" : "Modifier un correspondant",
    content: <CorrespondantForm  submitRef={submitRef} parentAlertId={parentAlertId} correspondant={correspondant} />,
    secondaryActions: correspondant?.id && [
      {
        title: i18n.t('common:button.delete'),
        color: theme().palette.error.main,
        action: (parentAlertId) => store.dispatch(deleteCorrespondantFormActionCreator(correspondant, parentAlertId, cb))
      },
    ],
    actionTitle: correspondant?.id ? i18n.t('common:interface.edit') : i18n.t('common:interface.add'),
    action: async (values, progress) => {      
      
      try {
        progress.handleTrigger()
        console.log('handle submit')
        const values =  await submitRef.current()
        if(!values) return;

        let promise;

        if(correspondant && correspondant.id) {
          promise = putCorrespondantRoutinePromiseCreator({values, id: correspondant.id}, store.dispatch)
        }
        else {
          promise = postCorrespondantRoutinePromiseCreator({ values }, store.dispatch)
        }

        const res = await promise; 

        cb(null, {action: correspondant && correspondant.id ? 'put' : 'post', id: res.result})
        console.log('after submit')
  
        return true
      }
      catch (e) {
        //afficher l'erreur
        console.log(e)
        cb(e)
        store.dispatch(errorActionCreator())
        return false
      }
      finally {
        progress.handleFulfill()
      }
    
    }
  })
}



export const deleteCorrespondantFormActionCreator = (correspondant, parentAlertId, cb = () => {}) => (
  alertRoutine.show({
    type: 'dialog',
    maxWidth: 'xs',
    parent: parentAlertId,
    title: i18n.t('correspondant.delete correspondant'),
    content: i18n.t('correspondant.delete correspondant detail'),
    action: async (values) => {
      
      try {
        const res = await deleteCorrespondantRoutinePromiseCreator({
          id: correspondant.id,
        }, store.dispatch)   
        
        cb(null, {action: 'delete', id: res.result})
        return true
      }
      catch (e) {
        //afficher l'erreur
        cb(e)
        store.dispatch(errorActionCreator())
        return false
      }
      finally {
      }         
    }
  })
)

const errorActionCreator = () => (
  alertRoutine.show({
    type: 'snack',
    title: i18n.t('common:interface.an error occured'),
    severity: 'error'
  })
)
